import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE, Language, storeLanguage } from '../../utils/language';

let nextId = 0;

/** Round flags in the style of the language switcher on conectio.io */
@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent {
  // Unique clip-path id, in case the switcher is rendered more than once on a page
  readonly clipId = `lang-flag-clip-${nextId++}`;

  readonly languages: { code: Language; label: string }[] = [
    { code: 'es', label: 'Español' },
    { code: 'en', label: 'English' },
    { code: 'ca', label: 'Català' },
    { code: 'fr', label: 'Français' },
  ];

  constructor(private translate: TranslateService) {}

  get current(): string {
    return this.translate.getCurrentLang() || DEFAULT_LANGUAGE;
  }

  select(lang: Language) {
    this.translate.use(lang);
    storeLanguage(lang);
  }
}
